"use client";

const FloatingElements = () => {
  return (
    <>
      <div
        className="fixed top-10 right-10 text-5xl animate-bounce hover:scale-125 transition-transform cursor-pointer"
        style={{ animationDelay: "1s" }}
      >
        ⭐
      </div>
      <div
        className="fixed bottom-20 left-10 text-4xl animate-bounce hover:scale-125 transition-transform cursor-pointer"
        style={{ animationDelay: "2s" }}
      >
        🌈
      </div>
      <div
        className="fixed top-1/3 left-5 text-3xl animate-bounce hover:scale-125 transition-transform cursor-pointer"
        style={{ animationDelay: "0.5s" }}
      >
        ✨
      </div>
      <div
        className="fixed top-1/2 right-5 text-4xl animate-bounce hover:scale-125 transition-transform cursor-pointer"
        style={{ animationDelay: "1.5s" }}
      >
        🎉
      </div>
      <div
        className="fixed bottom-1/3 right-16 text-3xl animate-bounce hover:scale-125 transition-transform cursor-pointer"
        style={{ animationDelay: "0.8s" }}
      >
        🚀
      </div>
    </>
  );
};

export default FloatingElements;
